import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import SplitType from "split-type";

const RevealText = ({ text }) => {
  const textRef = useRef(null);

  useEffect(() => {
    if (!textRef.current) return;

    // Split text into lines
    const splitText = new SplitType(textRef.current, {
      types: "lines",
    });

    // Animate each line
    gsap.from(splitText.lines, {
      y: "100%",
      opacity: 0,
      stagger: 0.2,
      duration: 1,
      ease: "power3.out",
    });

    return () => splitText.revert(); // Clean up
  }, []);

  return (
    <h4 className="tp-hero-3-title tp_reveal_anim" ref={textRef}>
      {text}
    </h4>
  );
};

export default RevealText;
